import { StringOptions, Type } from '@sinclair/typebox';

export const IsoDateTimeSchema = (options?: StringOptions) =>
  Type.String({
    ...options,
    format: 'date-time',
    description:
      `${options?.description ?? ''} Must use a supported date-time format. See [supported date formats](https://developer.unipile.com/v2.0/reference/api-usage#dates).`.trim(),
  });

export const IsoDateSchema = (options?: StringOptions) =>
  Type.String({
    ...options,
    format: 'date',
    description:
      `${options?.description ?? ''} Must use a supported date format. See [supported date formats](https://developer.unipile.com/v2.0/reference/api-usage#dates).`.trim(),
  });
